import { store } from '@/store';
import api from '..';
import { AUTH_TOKEN } from '@/constants';
import { User } from '@/models/user';

const getLoggedUser = async () => {
  try {
    console.log('chek then api');
    const baseUrl = process.env.VUE_APP_API_URL;
    const response = await api.get<User>(`${baseUrl}/me`);
    // console.log('getter user api', response);

    return response.data;
  } catch (error) {
    // console.log(error);
    store.commit('LOGOUT_USER');
    localStorage.removeItem(AUTH_TOKEN);
  }
};

export default getLoggedUser;
